import { render, staticRenderFns } from "./assetAllocationScheme.vue?vue&type=template&id=4dd898be&"
import script from "./assetAllocationScheme.vue?vue&type=script&lang=js&"
export * from "./assetAllocationScheme.vue?vue&type=script&lang=js&"
import style0 from "./assetAllocationScheme.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports